import { render, staticRenderFns } from "./List-ajuste-estoque.vue?vue&type=template&id=f75e7cdc&"
import script from "./List-ajuste-estoque.vue?vue&type=script&lang=js&"
export * from "./List-ajuste-estoque.vue?vue&type=script&lang=js&"
import style0 from "./List-ajuste-estoque.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports